import Vue from 'vue';
import ediOrderTransformer from './../../transformers/ediOrder';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('fetchCurrentEdiOrder', ediOrderTransformer.fetch(data));
  resolve(data);
};

export default (id, ediOrder) => (
  new Promise((resolve, reject) => {
    let url = `edi_orders/${id}/cancel`;

    if (localStorage.getItem('is_admin')) {
      url = `edi_orders/${id}/cancel?is_admin=true`;
    }

    Vue.$http
      .post(url, ediOrderTransformer.send(ediOrder))
      .then((response) => {
        success(response.data, resolve);
      })
      .catch(() => {
        reject();
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/ediOrder/cancel.js